'use client'

import { useTranslations } from 'next-intl'
import { ComponentType, SVGProps } from 'react'

import {
  SafeRental,
  ReasonableContract,
  FastVacancyResolution,
} from '@/shared/asset'
import { useRouter } from '@/shared/i18n'
import { SignUpIntro } from '@/widgets/sign-up'

export const SignUpGuestIntro = () => {
  const router = useRouter()

  const t = useTranslations('signup_guest_landing')

  const content: {
    title: string
    description: string
    image: ComponentType<SVGProps<SVGSVGElement>>
  }[] = [
    {
      title: t('safe_contract_title'),
      description: t('safe_contract_description'),
      image: SafeRental,
    },
    {
      title: t('fast_contract_title'),
      description: t('fast_contract_description'),
      image: FastVacancyResolution,
    },
    {
      title: t('reasonable_contract_title'),
      description: t('reasonable_contract_description'),
      image: ReasonableContract,
    },
  ]

  const handleButtonClick = () => {
    router.push('/sign-up/guest?step=terms')
  }

  return (
    <SignUpIntro
      title={t('title')}
      content={content}
      buttonText={t('button.start_signup')}
      onButtonClick={handleButtonClick}
    />
  )
}
